import { render, staticRenderFns } from "./btnFlexService.vue?vue&type=template&id=74405982&"
import script from "./btnFlexService.vue?vue&type=script&lang=js&"
export * from "./btnFlexService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports